export class SharedCvDataActions {
  static readonly anonyme = class {
    static readonly type = '[shared-cv-data] anonyme action';
  };

  static readonly getCvData = class {
    static readonly type = '[shared-cv-data] get cv data';
    constructor(
      public companyId: string,
      public data: string,
    ) {}
  };
}
